<script setup lang="ts">
import { EditableChip } from '@/design-system';

type PropsType = {
    mode?: 'chip' | 'input';
    data?: string | string[];
    displayText?: string;
    placeholder?: string;
    items?: string[];
    loading?: boolean;
    showClose?: boolean;
    autofocus?: boolean;
    autoOpenMenu?: boolean;
    autoCloseMenu?: boolean;
    isDateField?: boolean;
    multiple?: boolean;
};

const props = withDefaults(defineProps<PropsType>(), {
    mode: 'chip',
    items: () => [],
    loading: false,
    showClose: false,
    autofocus: false,
    autoOpenMenu: false,
    autoCloseMenu: false,
    isDateField: false,
    multiple: false,
});

const emit = defineEmits<{
    select: [value: string | string[]];
    remove: [];
    click: [];
    'update:menu': [value: boolean];
    search: [query: string];
}>();

const handleSelect = (value: unknown) => {
    // Multi-select emits the raw string array; single-select coerces to string.
    emit('select', props.multiple ? ((value ?? []) as string[]) : String(value));
};

const handleRemove = () => {
    emit('remove');
};

const handleClick = () => {
    emit('click');
};

const handleMenuToggle = (value: boolean) => {
    emit('update:menu', value);
};

const handleSearch = (query: string) => {
    emit('search', query);
};
</script>

<template>
    <EditableChip
        :mode="props.mode"
        type="value"
        :data="props.data"
        :display-text="props.displayText"
        :placeholder="props.placeholder"
        :items="props.items"
        :loading="props.loading"
        :show-close="props.showClose"
        :autofocus="props.autofocus"
        :auto-open-menu="props.autoOpenMenu"
        :auto-close-menu="props.autoCloseMenu"
        :is-date-field="props.isDateField"
        :multiple="props.multiple"
        @select="handleSelect"
        @remove="handleRemove"
        @click="handleClick"
        @update:menu="handleMenuToggle"
        @search="handleSearch"
    />
</template>
